/**
 * sword-configurator.js
 * Updated: Smooth 3-Step Navigation & Smart Auto-Category Distribution
 */

const CONFIGURATOR_API = 'https://darkcyan-snake-921645.hostingersite.com/public/api/configurator';
const BASE_VARIANT_ID = '53358319796587';

const BLADE_COLORS = {
    'black': {
        c0: '#1a1a22',
        c1: '#2a2a38'
    },
    'blue': {
        c0: '#0d1b3e',
        c1: '#1a3a6e'
    },
    'red': {
        c0: '#3e0d0d',
        c1: '#7a1a1a'
    },
    'gold': {
        c0: '#4a3800',
        c1: '#8a6a00'
    },
};

const WRAP_COLORS = {
    'black': '#1a0e06',
    'brown': '#5c2e00',
    'white': '#e8e0d0',
    'navy': '#0d1b3e',
    'red': '#6e0000',
};

const TSUBA_COLORS = {
    'HJ05': '#888',
    'HJ08': '#888',
    'HJ11': '#888',
    'T03': '#4a4a4a',
    'T07': '#4a4a4a',
    'TT12': '#4a4a4a',
    'CT12': '#b87333',
    'CT18': '#b87333',
};

const SAGEO_COLORS = {
    'SG-BLK': '#1a1a1a',
    'SG-BRN': '#5c2e00',
    'SG-NVY': '#0d1b3e',
    'SG-WHT': '#e8e0d0',
    'SG-GLD': '#b8860b',
};

const WRAP_BG_COLORS = {
    'C10': {
        bg: '#f0ebe0',
        fg: '#777'
    },
    'C15': {
        bg: '#0e2044',
        fg: '#fff'
    },
    'C16': {
        bg: '#111',
        fg: '#fff'
    },
    'C18': {
        bg: '#8a6800',
        fg: '#fff'
    },
    'C19': {
        bg: '#3a1a08',
        fg: '#fff'
    },
    'C20': {
        bg: '#1a3a6e',
        fg: '#fff'
    },
    'C11': {
        bg: '#4a1a6e',
        fg: '#fff'
    },
    'C12': {
        bg: '#8b0000',
        fg: '#fff'
    },
    'C13': {
        bg: '#4a8a3a',
        fg: '#fff'
    },
    'C14': {
        bg: '#1a4a2a',
        fg: '#fff'
    },
    'C17': {
        bg: '#7a1a3a',
        fg: '#fff'
    },
    'C201': {
        bg: '#111',
        fg: '#fff'
    },
    'C205': {
        bg: '#8a6800',
        fg: '#fff'
    },
    'C206': {
        bg: '#0a1228',
        fg: '#fff'
    },
    'C211': {
        bg: '#f0ebe0',
        fg: '#777'
    },
    'C215': {
        bg: '#6a0a1a',
        fg: '#fff'
    },
    'C210': {
        bg: '#4a1a6e',
        fg: '#fff'
    },
    'C214': {
        bg: '#1a5a4a',
        fg: '#fff'
    },
    'C203': {
        bg: '#3a1a08',
        fg: '#fff'
    },
    'RS-W-P': {
        bg: '#f0ebe0',
        fg: '#777'
    },
    'RS-W-FW': {
        bg: '#f0ebe0',
        fg: '#777'
    },
    'RS-B-P': {
        bg: '#111',
        fg: '#fff'
    },
    'RS-B-FW': {
        bg: '#111',
        fg: '#fff'
    },
    'RS-R-P': {
        bg: '#8b0000',
        fg: '#fff'
    },
    'RS-R-FW': {
        bg: '#8b0000',
        fg: '#fff'
    },
};

class SwordConfigurator {
    constructor(container) {
        this.container = container;
        this.parts = [];
        this.selections = {};
        this.total = 0;
        this.currentStep = 0;
        this.blockedWordsList = [];
        this.init();
    }

    async init() {
        this.showLoading();
        await this.fetchBlockedWords();
        await this.fetchOptions();

        if (!this.parts || this.parts.length === 0) return;


        this.parts.forEach(part => {
            let defaultChoice = null;


            if (part.choices && part.choices.length > 0) {
                defaultChoice = part.choices.find(c => c.is_base) || part.choices[0];
            } else if (part.groups && part.groups.length > 0) {
                const firstGroup = part.groups[0];
                if (firstGroup.choices && firstGroup.choices.length > 0) {
                    defaultChoice = firstGroup.choices.find(c => c.is_base) || firstGroup.choices[0];
                }
            }

            if (defaultChoice) {
                this.selections[part.slug] = {
                    choiceId: defaultChoice.id,
                    label: defaultChoice.label,
                    price: parseFloat(defaultChoice.price),
                    isBase: defaultChoice.is_base,
                    skuCode: defaultChoice.sku_code,
                    imageUrl: defaultChoice.image_url
                };
            }
        });

        this.render();
        this.updateSummary();
        
        this.showStep(0); 
    }


    async fetchBlockedWords() {
        try {
            const res = await fetch(`${CONFIGURATOR_API}/blocked-words`);
            const data = await res.json();
            if (data.success) {
                this.blockedWordsList = data.words.map(w => w.toLowerCase());
            }
        } catch (e) {
            console.warn("Could not load blocked words.");
        }
    }

   containsBlockedWord(text) {
        if (!text) return false;
        return this.blockedWordsList.some(word => {
            if (word.trim() === '') return false;
            const cleanWord = word.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
            const regex = new RegExp(`\\b${cleanWord}\\b`, 'i');
            return regex.test(text);
        });
    }
  
   validateNameInput(inputElement) {
        const errorMsg = document.getElementById('katana-name-live-error');
        const btn = document.getElementById('sc-final-checkout-btn');

        if (this.containsBlockedWord(inputElement.value)) {
            errorMsg.style.display = 'block';
            inputElement.style.borderColor = '#e71616';
            inputElement.classList.add('has-error');
            
            if (btn) {
                btn.disabled = true;
                btn.style.background = '#eee'; // Grey background
                btn.style.color = '#aaa';      // Grey text
                btn.style.cursor = 'not-allowed';
            }
        } else {
            errorMsg.style.display = 'none';
            inputElement.style.borderColor = '#111827';
            inputElement.classList.remove('has-error');
            
            if (btn) {
                btn.disabled = false;
                btn.style.background = '#000'; // Wapas Black color
                btn.style.color = '#fff';
                btn.style.cursor = 'pointer';
            }
        }
    }


    async fetchOptions() {
        try {
            const res = await fetch(`${CONFIGURATOR_API}/options`, {
                headers: {
                    'ngrok-skip-browser-warning': 'true',
                    'Content-Type': 'application/json'
                }
            });
            const data = JSON.parse(await res.text());

            if (data.success) {
                // SORTING LOGIC ADDED HERE
                // Loop through each part and sort its choices by price
                data.parts.forEach(part => {
                    // Sort direct choices by price (lowest to highest)
                    if (part.choices && part.choices.length > 0) {
                        part.choices.sort((a, b) => a.price - b.price);
                    }

                    // Sort choices within groups by price (lowest to highest)
                    if (part.groups && part.groups.length > 0) {
                        part.groups.forEach(group => {
                            if (group.choices) {
                                group.choices.sort((a, b) => a.price - b.price);
                            }
                        });
                    }
                });

                this.parts = data.parts;

                // LIVE SETTINGS FROM ADMIN BACKEND
                this.reviewSettings = data.review_settings || {
                    production_time: '~5 weeks',
                    bullet_2: 'Sword bag always Included free',
                    bullet_3: 'Free USA shipping on all orders',
                    box_title: 'Sword Box',
                    box_description: 'Collector display & storage box',
                    box_price: 56.00,
                    footer_badges: '✓ free usa shipping  ·  ✓ hand-forged to order  ·  ✓ secure checkout'
                };
            }
        } catch (e) {
            console.error('Failed to load options', e);
        }
    }

    render() {
        const initialPrice = window.SHOPIFY_BASE_PRICE || 'Calculating...';
        this.container.innerHTML = `
        <div class="sc-root">   
        <div id="sc-full-top-nav"></div>
    
          <div class="sc-columns">
            <div class="sc-left">
              <div class="sc-preview">
                ${this.svgMarkup()}
                <div class="sc-preview-text">Live Preview — Updates as you configure</div>
              </div>
              <div class="sc-summary">
                <div class="sc-summary-heading">
                  <span>YOUR BUILD</span>
                  <span style="font-size:9px;font-weight:500;color:#888;letter-spacing:0.08em;">CLICK TO EDIT</span>
                </div>
                <div class="sc-summary-rows" id="sc-rows"></div>
              </div>
              <div class="sc-summary-total">
              <div>
                <div class="sc-summary-total-label">TOTAL</div>
                <div class="sc-summary-total-price is-loading" id="sc-price">${initialPrice}</div>
                <div style="font-size:10px;color:#888;margin-top:2px;letter-spacing:0.05em;">retail pricing</div>
                </div>
                <div style="text-align:right;">
                  <div style="display:flex;align-items:baseline;gap:10px;justify-content:flex-end;">
                    
                    <div id="sc-sidebar-time-display" style="font-size:10px;color:#888;font-weight:600;letter-spacing:0.05em;">4 weeks</div>
                  </div>
                  
                </div>
              </div>
            </div>

            <div class="sc-right">
               <div class="sc-top-header" style="margin-bottom: 2rem; padding-bottom: 1.5rem; border-bottom: 1px solid #e5e7eb;">
                 
                 <div style="display: flex; align-items: center; gap: 8px; margin-bottom: 8px;">
                    <span style="color: #f5b300; font-size: 14px;">★★★★★</span>
                    <span style="font-size: 12px; color: #555; font-weight: 600;">Rated The #1 Katana Brand in the USA</span>
                 </div>
                 <div style="font-size: 11px; font-style: italic; color: #888; letter-spacing: 0.1em; text-transform: uppercase; margin-bottom: 10px; font-weight: 700;">
                    BUILD YOUR BLADE. DISPLAY YOUR LEGEND.
                 </div>

                 <h1 class="sc-main-title" style="font-size: 30px; font-weight: 800; color: #000; margin: 0 0 12px 0;">Customize Your Dream Katana (Hand-Forged)</h1>
                 
                <div class="sc-header-price is-loading" id="sc-top-price-display" style="font-size: 34px; font-weight: 900; color: #000; margin-bottom: 10px;">${initialPrice}</div>

                    <ul style="list-style: none; padding: 0; margin: 0 0 20px 0;">
                        <li style="display: flex; align-items: center; gap: 10px; margin-bottom: 8px; font-size: 13px; font-weight: 700; color: #111;">
                            <span style="background: #e71616; color: white; border-radius: 50%; width: 18px; height: 18px; display: flex; justify-content: center; align-items: center; font-size: 10px;">✔</span> Rated The #1 Katana Brand in the USA
                        </li>
                        <li style="display: flex; align-items: center; gap: 10px; margin-bottom: 8px; font-size: 13px; font-weight: 700; color: #111;">
                            <span style="background: #e71616; color: white; border-radius: 50%; width: 18px; height: 18px; display: flex; justify-content: center; align-items: center; font-size: 10px;">✔</span> Over 300,000 Happy Customers
                        </li>
                        <li style="display: flex; align-items: center; gap: 10px; font-size: 13px; font-weight: 700; color: #111;">
                            <span style="background: #e71616; color: white; border-radius: 50%; width: 18px; height: 18px; display: flex; justify-content: center; align-items: center; font-size: 10px;">✔</span> 97.1% Customer Satisfaction Rating
                        </li>
                    </ul>
               </div>

               <div class="sc-sections" id="sc-sections"></div>
            </div>
          </div>
        </div>`;

        this.buildSections();
    }

    svgMarkup() {
        return `<svg id="sword-svg" viewBox="0 0 480 148" xmlns="http://www.w3.org/2000/svg" width="100%" style="overflow:visible">
          <defs>
            <linearGradient id="blg" x1="0%" y1="0%" x2="0%" y2="100%">
              <stop id="bl0" offset="0%" stop-color="#1a1a22" stop-opacity="0.95"/>
              <stop id="bl1" offset="45%" stop-color="#2a2a38"/>
              <stop offset="100%" stop-color="#111118"/>
            </linearGradient>
            <linearGradient id="hbg" x1="0%" y1="0%" x2="0%" y2="100%">
              <stop offset="0%" stop-color="#bbb"/>
              <stop offset="100%" stop-color="#888"/>
            </linearGradient>
            <linearGradient id="fcg" x1="0%" y1="0%" x2="0%" y2="100%">
              <stop offset="0%" stop-color="#555"/>
              <stop offset="100%" stop-color="#222"/>
            </linearGradient>
          </defs>
          <line x1="160" y1="28" x2="160" y2="71" stroke="#ddd" stroke-width="0.8" stroke-dasharray="3,2"/>
          <text font-family="Arial,sans-serif" text-anchor="middle">
            <tspan x="160" y="11" font-size="7" fill="#bbb" font-weight="700" letter-spacing="0.8">BLADE</tspan>
            <tspan x="160" dy="11" font-size="8.5" fill="#555" font-weight="700" id="svg-lbl-blade">—</tspan>
          </text>
          <line x1="418" y1="28" x2="418" y2="73" stroke="#ddd" stroke-width="0.8" stroke-dasharray="3,2"/>
          <text font-family="Arial,sans-serif" text-anchor="middle">
            <tspan x="418" y="11" font-size="7" fill="#bbb" font-weight="700" letter-spacing="0.8">TSUKA-MAKI</tspan>
            <tspan x="418" dy="11" font-size="8.5" fill="#555" font-weight="700" id="svg-lbl-wrap">—</tspan>
          </text>
          <polygon id="sv-blade" points="356,71 356,89 10,80" fill="url(#blg)"/>
          <path d="M354,80 Q240,79.5 120,80 Q60,80.2 10,80" stroke="rgba(255,255,255,0.15)" stroke-width="1.2" fill="none"/>
          <path d="M354,75 L55,78" stroke="rgba(180,180,220,0.12)" stroke-width="2" fill="none" stroke-linecap="round"/>
          <polygon points="10,80 21,76 21,78.5" fill="white" opacity="0.25"/>
          <rect x="353" y="68" width="11" height="24" rx="0.5" fill="url(#hbg)"/>
          <ellipse id="sv-tO" cx="370" cy="80" rx="5.5" ry="21" fill="#888"/>
          <ellipse id="sv-tI" cx="370" cy="80" rx="5.5" ry="21" fill="none" stroke="#aaa" stroke-width="0.8" opacity="0.5"/>
          <rect x="374" y="74" width="6" height="12" rx="0.5" fill="url(#fcg)"/>
          <rect id="sv-tk" x="379" y="73" width="78" height="14" rx="1" fill="#1a0e06"/>
          <g id="sv-wr">
            <line x1="386" y1="73" x2="383" y2="87" stroke="rgba(0,0,0,0.55)" stroke-width="1.8"/>
            <line x1="393" y1="73" x2="390" y2="87" stroke="rgba(0,0,0,0.55)" stroke-width="1.8"/>
            <line x1="400" y1="73" x2="397" y2="87" stroke="rgba(0,0,0,0.55)" stroke-width="1.8"/>
            <line x1="407" y1="73" x2="404" y2="87" stroke="rgba(0,0,0,0.55)" stroke-width="1.8"/>
            <line x1="414" y1="73" x2="411" y2="87" stroke="rgba(0,0,0,0.55)" stroke-width="1.8"/>
            <line x1="421" y1="73" x2="418" y2="87" stroke="rgba(0,0,0,0.55)" stroke-width="1.8"/>
            <line x1="428" y1="73" x2="425" y2="87" stroke="rgba(0,0,0,0.55)" stroke-width="1.8"/>
            <line x1="435" y1="73" x2="432" y2="87" stroke="rgba(0,0,0,0.55)" stroke-width="1.8"/>
            <line x1="442" y1="73" x2="439" y2="87" stroke="rgba(0,0,0,0.55)" stroke-width="1.8"/>
            <line x1="449" y1="73" x2="446" y2="87" stroke="rgba(0,0,0,0.55)" stroke-width="1.8"/>
          </g>
          <rect x="455" y="73" width="6" height="14" rx="0.5" fill="#2a2a2a"/>
          <path id="sv-sg" d="M458,87 Q461,96 455,102 Q449,108 454,115" stroke="#2a2a2a" stroke-width="2.5" fill="none" stroke-linecap="round"/>
          <line x1="370" y1="127" x2="370" y2="101" stroke="#ddd" stroke-width="0.8" stroke-dasharray="3,2"/>
          <text font-family="Arial,sans-serif" text-anchor="middle">
            <tspan x="370" y="131" font-size="7" fill="#bbb" font-weight="700" letter-spacing="0.8">TSUBA</tspan>
            <tspan x="370" dy="11" font-size="8.5" fill="#555" font-weight="700" id="svg-lbl-tsuba">—</tspan>
          </text>
          <line x1="455" y1="127" x2="455" y2="115" stroke="#ddd" stroke-width="0.8" stroke-dasharray="3,2"/>
          <text font-family="Arial,sans-serif" text-anchor="middle">
            <tspan x="455" y="131" font-size="7" fill="#bbb" font-weight="700" letter-spacing="0.8">SAGEO</tspan>
            <tspan x="455" dy="11" font-size="8.5" fill="#555" font-weight="700" id="svg-lbl-sageo">—</tspan>
          </text>
        </svg>`;
    }

    buildSections() {
        const wrap = document.getElementById('sc-sections');
        if (!wrap) return;

        // --- 100% DASHBOARD DRIVEN LOGIC ---
        this.tabCounts = {};
        this.uniqueTabs = []; // Dynamic tabs list from Admin Panel

        this.parts.forEach((part) => {

            let tab = part.tab_name;


            if (!tab || tab.trim() === '') {
                tab = 'Blade';
            }
            part.tab_name = tab;


            if (!this.uniqueTabs.includes(tab)) {
                this.uniqueTabs.push(tab);
            }

            if (!this.tabCounts[tab]) this.tabCounts[tab] = 0;
            this.tabCounts[tab]++;

            part.tab_position = this.tabCounts[tab];
        });

        this.parts.forEach(part => {
            part.tab_total = this.tabCounts[part.tab_name];
        });

        // BUILD TOP NAVIGATION BAR (With Dynamic Connecting Lines)
        // ---------------------------------------------------------
        const topNavContainer = document.getElementById('sc-full-top-nav');
        if (topNavContainer) {
            topNavContainer.innerHTML = ''; // Clear previous if any

            const topNav = document.createElement('div');
            topNav.id = 'sc-top-nav-container';
            topNav.style.display = 'flex';
            topNav.style.justifyContent = 'space-between';
            topNav.style.alignItems = 'center';
            topNav.style.borderBottom = '1px solid #e5e5e5';
            topNav.style.padding = '10px 25px';
            topNav.style.marginBottom = '30px';


            const tabsWrapper = document.createElement('div');
            tabsWrapper.style.display = 'flex';
            tabsWrapper.style.alignItems = 'center';
            tabsWrapper.style.flex = '0 0 1%';

            this.uniqueTabs.forEach((tabName, index) => {
                // 1. Create the Tab Item (Circle + Text)
                const tabItem = document.createElement('div');
                tabItem.className = 'sc-tab-item';
                tabItem.dataset.tab = tabName;
                tabItem.style.display = 'flex';
                tabItem.style.alignItems = 'center';
                tabItem.style.flex = '0 0 auto';
                tabItem.style.color = '#b3b3b3';
                tabItem.style.fontWeight = '800';
                tabItem.style.fontSize = '11px';
                tabItem.style.textTransform = 'uppercase';
                tabItem.style.letterSpacing = '0.05em';
                tabItem.style.whiteSpace = 'nowrap';
                tabItem.style.cursor = 'pointer';
                tabItem.innerHTML = `
                    <span class="sc-tab-circle" style="display: flex; justify-content: center; align-items: center; width: 44px; height: 44px; border-radius: 50%; border: 2px solid #e5e5e5; margin-right: 10px; font-size: 11px; font-weight: 800; background: #fff; transition: background 0.4s ease;">
                        0%
                    </span>
                    <span class="tab-name">${tabName}</span>
                `;
                tabItem.addEventListener('click', () => {
                    const targetIndex = this.parts.findIndex(p => p.tab_name === tabName);

                    if (targetIndex !== -1) {
                        this.showStep(targetIndex);
                    }
                });
                tabsWrapper.appendChild(tabItem);

                // 2. Create the Connecting Line (between tabs)
                if (index < this.uniqueTabs.length - 1) {
                    const line = document.createElement('div');
                    line.className = 'sc-tab-line';
                    line.style.flex = '1';
                    line.style.height = '2px';
                    line.style.background = '#e5e5e5';
                    line.style.margin = '0 15px';
                    line.style.borderRadius = '2px';
                    line.style.display = 'block';
                    line.style.minWidth = '30px';
                    tabsWrapper.appendChild(line);
                }
            });

            // 3. Create the Right Side Step Counter
            const stepCounter = document.createElement('div');
            stepCounter.id = 'sc-step-counter-header';
            stepCounter.style.color = '#e71616';
            stepCounter.style.fontWeight = '800';
            stepCounter.style.fontSize = '12px';
            stepCounter.style.letterSpacing = '0.1em';
            stepCounter.style.border = '1px solid #e71616';
            stepCounter.style.backgroundColor = '#fff';
            stepCounter.style.padding = '8px 18px';
            stepCounter.style.marginLeft = '20px';
            stepCounter.style.textTransform = 'uppercase';
            stepCounter.style.whiteSpace = 'nowrap';

            topNav.appendChild(tabsWrapper);
            topNav.appendChild(stepCounter);
            topNavContainer.appendChild(topNav);
        }

        // BUILD SECTIONS
        this.parts.forEach((part, i) => {
            const sec = document.createElement('div');
            sec.className = 'sc-part-section';
            sec.id = `sc-sec-${i}`;
            sec.style.display = 'none';

            let html = `
                <div style="font-size: 11px; font-weight: 800; color: #e71616; margin-bottom: 5px; letter-spacing: 0.1em; text-transform: uppercase;">
                    ${part.tab_name} <span style="color:#ccc; margin: 0 4px;">|</span> ${part.tab_position} / ${part.tab_total}
                </div>
                <h2 style="font-size: 26px; font-weight: 800; margin: 0 0 4px 0;">${part.name}</h2>
                ${part.description ? `<p style="color: #666; font-size: 14px; margin: 0 0 20px 0;">${part.description}</p>` : ''}
               
                <div class="sc-groups-wrapper" style="margin-top: 20px;">
            `;

            if (part.groups && part.groups.length > 0) {
                part.groups.forEach((group, gIndex) => {
                    const isOpen = false;
                    const priceLbl = this.groupPriceLabel(group);
                    html += `
                    <div class="sc-accordion" style="margin-bottom: 10px; border: 1px solid #e5e7eb;">
                        <div class="sc-accordion-header"
                             data-group-id="${group.id}"
                             data-part-slug="${part.slug}"
                             onclick="window.configuratorInstance.toggleAccordion(this)"
                             style="background: #f9fafb; padding: 14px 16px; cursor: pointer; display: flex; align-items: center; gap: 10px; font-weight: 800; font-size: 12px; text-transform: uppercase; color: #111;">
                            <span class="sc-acc-icon" style="color: #e71616; font-size: 14px; flex-shrink: 0; width: 12px;">${isOpen ? '−' : '+'}</span>
                            <span style="flex: 1;">${group.name}</span>
                            <span class="sc-acc-price-info" style="font-size: 11px; color: #888; font-weight: 600; text-transform: none;">${priceLbl}</span>
                        </div>
                        <div class="sc-accordion-content" style="display: ${isOpen ? 'block' : 'none'}; padding: 15px; border-top: 1px solid #e5e7eb;">
                            <div class="sc-grid ${part.slug.includes('length') ? 'sc-list-layout' : ''}" id="sc-grid-${part.slug}-${group.id}"></div>
                        </div>
                    </div>`;
                });
            } else {
                html += `<div class="sc-grid ${part.slug.includes('length') ? 'sc-list-layout' : ''}" id="sc-grid-${part.slug}-nogroup"></div>`;
            }

            html += `</div>`;

            if (part.alert_box_text != null && part.alert_box_text !== 'null' && part.alert_box_text.trim() !== '') {
                html += `
                <div style="background: #fdf8f0;border: 1px solid #e8dfc8;border-left: 3px solid #c09020;padding: 10px 14px;font-size: 12px;color: #7a5a20;margin-top: 12px;line-height: 1.6;">
                    ${part.alert_box_text}
                </div>
                `;
            }
            html += `
                <div style="display: flex; justify-content: space-between; margin-top: 30px; padding-top: 20px; border-top: 1px solid #eee;">
                    <button class="sc-btn sc-btn-back" onclick="window.configuratorInstance.changeStep(-1)" 
                        style="padding: 10px 20px; background: #fff; border: 1px solid #ddd; color: #333; font-size: 13px; text-transform: uppercase; font-weight: 700; cursor: pointer; visibility: ${i === 0 ? 'hidden' : 'visible'}">
                        ← Back
                    </button>
                    <button class="sc-btn sc-btn-next" onclick="window.configuratorInstance.changeStep(1)"
                        style="padding: 14px 28px; background: #e71616; color: #fff; border: none; border-radius: 0px; cursor: pointer; font-size: 14px; text-transform: uppercase; font-weight: 800; letter-spacing: 0.05em;">
                        ${i === this.parts.length - 1 ? 'Review Build →' : 'Next Step →'}
                    </button>
                </div>`;

            sec.innerHTML = html;
            wrap.appendChild(sec);

            if (part.groups && part.groups.length > 0) {
                part.groups.forEach(group => {
                    const grid = sec.querySelector(`#sc-grid-${part.slug}-${group.id}`);
                    if (group.choices && grid) {
                        group.choices.forEach(choice => {
                            grid.appendChild(this.createCard(part, choice));
                        });
                    }
                });
            } else if (part.choices) {
                const grid = sec.querySelector(`#sc-grid-${part.slug}-nogroup`);
                if (grid) {
                    part.choices.forEach(choice => {
                        grid.appendChild(this.createCard(part, choice));
                    });
                }
            }
        });

        // ---------------------------------------------------------
        // ---------------------------------------------------------
        // BUILD REVIEW STEP
        // ---------------------------------------------------------
        const initialPrice = window.SHOPIFY_BASE_PRICE || 'Calculating...';
        const settings = this.reviewSettings;
        let finalReviewTime = settings ? settings.production_time : '~5 weeks';
        for (const key in this.selections) {
            const sel = this.selections[key];
            if (sel && sel.label) {
                const choiceName = sel.label.toLowerCase();
                if (choiceName.includes('fully wrapped') || choiceName.includes('full wrap')) {
                    finalReviewTime = '~7 weeks';
                    break;
                }
            }
        }
        const reviewSec = document.createElement('div');
        reviewSec.className = 'sc-part-section';
        reviewSec.id = `sc-sec-${this.parts.length}`;
        reviewSec.style.display = 'none';
        reviewSec.innerHTML = `
            <h2 style="font-size: 32px; font-weight: 800; margin-bottom: 20px;">YOUR BUILD. <span style="color:#e71616;">REVIEW.</span></h2>
            <div class="rev-note">⚠ All prices shown are final retail prices.</div>
            <div id="sc-review-visual-preview" style="margin-bottom: 25px; padding: 30px 20px; background: #fafafa; border: 1px solid #e5e5e5; border-radius: 4px; text-align: center;">
                <div style="font-size: 11px; font-weight: 800; color: #888; margin-bottom: 20px; letter-spacing: 0.1em; text-transform: uppercase;">Your Custom Blade Preview</div>
                <div id="sc-review-svg-wrapper"></div>
            </div>

            <div style="background: #fff; border: 1px solid #e5e5e5; padding: 0; margin-bottom: 25px;">
                <h3 style="background:#000; color:#fff; padding:10px; margin:0; font-size:16px;">COMPLETE BUILD SUMMARY</h3>
                <div id="sc-review-summary-list" style="padding: 10px;"></div>
            </div>

            <div style="margin-bottom: 24px; padding: 20px; border: 1px solid #e5e7eb; border-radius: 4px; background-color: #f9fafb;">
    <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 6px;">
        <h3 style="font-size: 13px; font-weight: 800; color: #111827; margin: 0; text-transform: uppercase; letter-spacing: 0.05em;">
            <span style="margin-right: 8px;">⚔️</span>Name Your Katana
        </h3>
    </div>
    <p style="font-size: 13px; color: #6b7280; margin: 0 0 12px 0;">Every legend deserves a name. What will yours be?</p>
    
    <input type="text" id="custom-katana-name" maxlength="50" placeholder="e.g. Shadow Fang, Crimson Wind, The Arbiter..." 
           style="width: 100%; box-sizing: border-box; padding: 12px 14px; border: 1px solid #d1d5db; border-radius: 4px; font-size: 14px; color: #111827; outline: none; transition: border-color 0.15s ease-in-out;"
           onfocus="this.style.borderColor='#111827'" 
           onblur="if(!this.classList.contains('has-error')) this.style.borderColor='#d1d5db'"
           oninput="window.configuratorInstance.validateNameInput(this)">
    
    <!-- 🚨 LIVE ERROR MESSAGE DIV -->
    <div id="katana-name-live-error" style="display:none; color: #e71616; font-size: 12px; font-weight: 700; margin-top: 6px;">
        ⚠ This name contains restricted words.
    </div>
</div>
            <!-- 🟢 1. Green Bullets Section (Statically Added) -->
            <div style="margin-bottom: 15px; padding: 0 0px; font-size: 14px; color: #111; font-weight: 700;">
                <div style="display: flex; align-items: center; gap: 5px; margin-bottom: 0px;font-weight: 500;">
                    <span style="color: #1b7a24; font-size: 13px;line-height: 0;font-weight: 500;">●</span> Estimated Delivery Time: <span id="sc-review-delivery-time" style="font-weight: 900;font-size: 13px;color: #111;">${finalReviewTime}</span>
                </div>
                <div style="display: flex; align-items: center; gap: 5px; margin-bottom: 0px; font-weight: 500;">
                    <span style="color: #1b7a24; font-size: 13px;font-weight: 500;">●</span> ${settings.bullet_2}
                </div>
                <div style="display: flex; align-items: center; gap: 5px; margin-bottom: 0px;font-weight: 500;">
                    <span style="color: #1b7a24; font-size: 13px;font-weight: 500;">●</span> ${settings.bullet_3}
                </div>
            </div>
            <!-- 📦 2. Sword Box Add-on Card (Statically Added) -->
            <div style="display: flex;align-items: center;justify-content: space-between;gap: 12px;border: 1.5px solid #e0e0e0;padding: 14px 16px;margin-bottom: 16px;background: #fafafa;">
                <div>
                    <div style="font-weight: 700;color: #111;font-size: 13px;margin-bottom: 0px;">${settings.box_title}</div>
                    <div style="font-size: 11px;color: #aaa;">${settings.box_description}</div>
                </div>
                <div style="display: flex; align-items: center; gap: 20px;">
                    <span style="font-size: 13px;color: #888;font-weight: 600;white-space: nowrap;">+$${parseFloat(settings.box_price).toFixed(0)}</span>
                    <button type="button" id="sc-review-addon-box-btn" onclick="window.configuratorInstance.toggleReviewBox(${parseFloat(settings.box_price)})" style="background: transparent;color: #12141f;border: 1.5px solid #12141f;font-family: 'Barlow Condensed', sans-serif;font-size: 12px;font-weight: 700;
            padding: 7px 16px;cursor: pointer;text-transform: uppercase;letter-spacing: .06em;margin-left: 8px;white-space: nowrap;transition: all .15s;">Add</button>
                </div>
            </div>

            <button id="sc-final-checkout-btn" style="width: 100%; padding: 18px; font-size: 18px; font-weight: 800; background: #000; color: #fff; border: none; cursor: pointer; transition: all ease .5s;">
                ADD TO CART • <span id="sc-review-total-btn">${initialPrice}</span> 
            </button>
            <!-- 🔒 3. Footer Secure Checklist Badges -->
            <div style="font-size: 11px;color: #aaa;text-align: center;letter-spacing: .03em;margin-top: 10px;margin-bottom: 14px;">
            ${settings.footer_badges}
            </div>
            <div style="text-align:left; margin-top:10px;">
                <a href="javascript:window.configuratorInstance.changeStep(-1)" style="color:#666; text-decoration:underline; font-size: 12px;">← Edit Your Build</a>
            </div>
            <div id="sc-feedback-card" style="background:#fff;  padding:0px; text-align:left; margin-top: 24px; box-sizing: border-box;padding: 20px;border: 1px solid #e8e8e8">
                <h3 style="font-size: 13px;font-weight: 800;letter-spacing: .1em;text-transform: uppercase;color: #333;margin-bottom: 6px;">QUICK FEEDBACK</h3>
                <p style="color:#666; font-size:12px; margin:0 0 15px 0;">Help us improve! How was your builder experience?</p>
                
                <div id="sc-stars-row" style="font-size:26px; color:#ccc; cursor:pointer; margin-bottom:16px; display:flex; gap:6px; user-select:none;">
                    <span data-val="1" class="sc-star" style="color:#ccc; transition: color 0.15s;">☆</span>
                    <span data-val="2" class="sc-star" style="transition: color 0.15s;">☆</span>
                    <span data-val="3" class="sc-star" style="transition: color 0.15s;">☆</span>
                    <span data-val="4" class="sc-star" style="transition: color 0.15s;">☆</span>
                    <span data-val="5" class="sc-star" style="transition: color 0.15s;">☆</span>
                </div>
                
                <textarea id="sc-feedback-comment" placeholder="What features or options would you like to see? (optional)" style="width:100%; height:75px; padding:12px; border:1.5px solid #000; font-family:inherit; font-size:13px; box-sizing:border-box; margin-bottom:16px; outline:none; resize:none; color:#111; font-weight:500;"></textarea>
                
                <button type="button" id="sc-send-feedback-btn" onclick="window.configuratorInstance.submitFeedback()" style="width:100%; background:#12141f; color:#fff; border:none; padding:13px; font-size:12px; font-weight:700; letter-spacing:0.1em; text-transform:uppercase; cursor:pointer; transition: opacity 0.2s;">SEND FEEDBACK</button>
            </div>
        `;
        wrap.appendChild(reviewSec);
        this.selectedFeedbackRating = 0;
        const stars = reviewSec.querySelectorAll('.sc-star');
        stars.forEach(star => {
            star.addEventListener('click', (e) => {
                const clickedVal = parseInt(e.target.dataset.val);
                this.selectedFeedbackRating = clickedVal;
                stars.forEach((s, idx) => {
                    if (idx < clickedVal) {
                        s.style.color = '#f5b300';
                        s.textContent = '★';
                    } else {
                        s.style.color = '#ccc';
                        s.textContent = '☆';
                    }
                });
            });
        });
        const finalBtn = reviewSec.querySelector('#sc-final-checkout-btn');
        // if(finalBtn) finalBtn.addEventListener('click', () => this.addToCart());

        this.updateTabNav();
    }
    toggleReviewBox(boxPrice) {
        const btn = document.getElementById('sc-review-addon-box-btn');
        if (!btn) return;

        if (this.isBoxAdded) {
            // Remove box state
            this.isBoxAdded = false;
            btn.style.background = 'transparent';
            btn.style.color = '#12141f';
            btn.textContent = 'Add';
            delete this.selections['review-sword-box'];
        } else {
            // Add box state
            this.isBoxAdded = true;
            btn.style.background = '#12141f';
            btn.style.color = '#fff';
            btn.textContent = 'Added';
            this.selections['review-sword-box'] = {
                label: this.reviewSettings.box_title + ' (Included)'
            };
        }

        // Live prices calculation backend API  sync
        this.fetchPrice();
    }

    async submitFeedback() {
        const commentInput = document.getElementById('sc-feedback-comment');
        const btn = document.getElementById('sc-send-feedback-btn');
        if (!btn) return;

        const comment = commentInput ? commentInput.value.trim() : '';
        const rating = this.selectedFeedbackRating || 0;

        try {
            btn.disabled = true;
            btn.innerHTML = 'SUBMITTING...';

            const res = await fetch(`${CONFIGURATOR_API}/feedback`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'ngrok-skip-browser-warning': 'true'
                },
                body: JSON.stringify({
                    rating,
                    comment
                })
            });
            const data = await res.json();

            if (data.success) {
                btn.innerHTML = 'SENT ✓';
                btn.style.cursor = 'not-allowed';

                const oldMsg = document.getElementById('sc-feedback-success-msg');
                if (oldMsg) oldMsg.remove();

                const msgElement = document.createElement('div');
                msgElement.id = 'sc-feedback-success-msg';
                msgElement.style.cssText = 'text-align: center; color: #1b7a24; font-weight: 700; font-size: 14px; margin-top: 15px; font-family: inherit; width: 100%;';
                msgElement.textContent = 'Thank you for your feedback!';

                btn.after(msgElement);
            }
        } catch (e) {
            console.error('Feedback submission error:', e);
            btn.disabled = false;
            btn.innerHTML = 'SEND FEEDBACK';
        }
    }
    updateTabNav() {
        if (!this.parts || this.parts.length === 0) return;

        const isReviewStep = this.currentStep >= this.parts.length;
        const currentPart = isReviewStep ? null : this.parts[this.currentStep];
        const activeTabName = isReviewStep ? 'REVIEW' : currentPart.tab_name;

        const tabItems = document.querySelectorAll('.sc-tab-item');
        const tabLines = document.querySelectorAll('.sc-tab-line');
        let activeFound = false;

        tabItems.forEach((item, index) => {
            const circle = item.querySelector('.sc-tab-circle');
            const tabName = item.dataset.tab;

            if (isReviewStep) {
                // ALL TABS COMPLETED: Green circle, 100%, solid black lines
                item.style.color = '#b3b3b3';
                circle.style.borderColor = '#1b7a24';
                circle.style.backgroundColor = '#1b7a24';
                circle.style.color = '#fff';
                circle.textContent = '100%';

                if (tabLines[index]) tabLines[index].style.background = '#111';
                return;
            }

            if (tabName === activeTabName) {
                // ACTIVE TAB: Solid black circle, text white
                activeFound = true;
                item.style.color = '#111';
                circle.style.borderColor = '#111';
                circle.style.backgroundColor = '#111';
                circle.style.color = '#fff';

                // Calculate precise percentage for current tab
                let pct = Math.round((currentPart.tab_position / currentPart.tab_total) * 100);
                if (pct === 100 && currentPart.tab_position !== currentPart.tab_total) pct = 99;
                circle.textContent = pct + '%';

                // DYNAMIC LINE FILL: Gradient fills the line based on the exact percentage
                if (tabLines[index]) {
                    tabLines[index].style.background = `linear-gradient(to right, #111 ${pct}%, #e5e5e5 ${pct}%)`;
                }
            } else if (!activeFound) {
                // PAST TABS: Solid green circle, 100%, line fully black
                item.style.color = '#b3b3b3';
                circle.style.borderColor = '#1b7a24';
                circle.style.backgroundColor = '#1b7a24';
                circle.style.color = '#fff';
                circle.textContent = '100%';

                // Complete past lines with solid black
                if (tabLines[index]) tabLines[index].style.background = '#111';
            } else {
                // FUTURE TABS: Grey circle, 0%, line fully grey
                item.style.color = '#b3b3b3';
                circle.style.borderColor = '#e5e5e5';
                circle.style.backgroundColor = '#fff';
                circle.style.color = '#b3b3b3';
                circle.textContent = '0%';

                // Keep future lines grey
                if (tabLines[index]) tabLines[index].style.background = '#e5e5e5';
            }
        });

        // Update the Right-Side Step Counter
        const stepCounter = document.getElementById('sc-step-counter-header');
        if (stepCounter) {
            if (!isReviewStep) {
                stepCounter.innerHTML = `${currentPart.tab_name} <span style="margin: 0 6px;">|</span> ${currentPart.tab_position} / ${currentPart.tab_total}`;
            } else {
                stepCounter.innerHTML = `REVIEW <span style="margin: 0 6px;">|</span> FINAL`;
            }
        }
    }

    shortKey(name) {
        const map = {
            'Steel Type': 'STEEL',
            'Blade Length': 'BLADE',
            'Sharpness': 'SHARPNESS',
            'Handle Length': 'HANDLE',
            'Wrapping Material': 'WRAP',
            'Wrapping Style': 'STYLE',
            'Rayskin': 'RAYSKIN',
            'Tsuba (Hand Guard)': 'TSUBA',
            'Saya (Scabbard)': 'SAYA',
            'Sageo (Scabbard Cord)': 'SAGEO',
            'Sword Bag': 'BAG',
            'Sword Stand': 'STAND',
        };
        return map[name] || name.split(' ')[0].toUpperCase();
    }

    groupPriceLabel(group) {
        if (!group.choices || !group.choices.length) return '';
        const prices = group.choices.map(c => parseFloat(c.price));
        const min = Math.min(...prices);
        const max = Math.max(...prices);
        if (min === 0 && max === 0) return 'Included';
        if (min === max) return (min > 0 ? '+$' : '') + min.toFixed(0);
        if (min === 0) return 'Incl. – +$' + max.toFixed(0);
        return '$' + min.toFixed(0) + ' – $' + max.toFixed(0);
    }

    toggleAccordion(header) {
        const content = header.nextElementSibling;
        const icon = header.querySelector('.sc-acc-icon');
        const isHidden = content.style.display === 'none';
        content.style.display = isHidden ? 'block' : 'none';
        icon.textContent = isHidden ? '−' : '+';
    }

    createCard(part, choice) {
        const card = document.createElement('div');

        // 🚨 NEW LOGIC: Check if the part slug contains the word 'length'
        const isLength = part.slug.includes('length');

        // Apply the new CSS list class if it's a length option, otherwise use the standard card class
        card.className = isLength ? 'sc-card sc-list-card' : 'sc-card';
        card.dataset.part = part.slug;
        card.dataset.choice = choice.id;

        const lbl = choice.label;
        const price = parseFloat(choice.price);

        //  LENGTH LAYOUT: Render the horizontal list HTML for length options
        if (isLength) {
            let badgeText = choice.is_base ? 'STANDARD +$0' : (price > 0 ? `+$${price.toFixed(0)}` : 'INCLUDED');
            card.innerHTML = `
                <div class="sc-card-label">${lbl}</div>
                <div class="sc-badge">${badgeText}</div>
            `;
            card.addEventListener('click', () => this.pick(part, choice, card));
            return card;
        }

        // --- REMAINING STANDARD SQUARE CARD CODE ---
        const colBg = WRAP_BG_COLORS[choice.sku_code];

        let visualHtml;
        if (choice.image_url && choice.image_url.trim() !== '' && choice.image_url !== 'null' && choice.image_url !== null) {
            visualHtml = `<img src="${choice.image_url}" alt="${lbl}" class="sc-card-image" style="width:100%; height:120px; object-fit:cover; display:block;" />`;
        } else if (colBg) {
            const colorName = lbl.includes('—') ? lbl.split('—').pop().trim() : lbl;
            visualHtml = `<div style="background:${colBg.bg};height:120px;display:flex;flex-direction:column;justify-content:center;align-items:center;margin:-10px -8px 10px -8px;">
                <div style="font-size:20px;font-weight:800;color:${colBg.fg};opacity:0.75;letter-spacing:0.05em;">${choice.sku_code}</div>
                <div style="font-size:10px;font-weight:700;color:${colBg.fg};opacity:0.5;text-transform:uppercase;margin-top:4px;letter-spacing:0.1em;">${colorName}</div>
            </div>`;
        } else {
            visualHtml = `<div class="sc-card-icon" style="height:100px; display:flex; align-items:center; justify-content:center; font-size:32px;">${this.icon(choice.sku_code)}</div>`;
        }

        const priceDisplay = (part.slug === 'steel-type') ?
            '$' + price.toFixed(0) :
            choice.is_base ?
            '$' + price.toFixed(0) :
            price > 0 ? '+$' + price.toFixed(0) : 'Included';

        card.innerHTML = `
            ${visualHtml}
            <div class="sc-card-label">${lbl}</div>
            <div class="sc-card-price">${priceDisplay}</div>`;

        card.addEventListener('click', () => this.pick(part, choice, card));
        return card;
    }

    toggleEngravingInput(part, selectedChoiceState, cardElement) {
        if (part.slug !== 'engravings') return;

        // Clean out any stale duplicates on the layout DOM
        const existingContainer = document.getElementById('engraving-text-container');
        if (existingContainer) existingContainer.remove();

        // 🚨 BUG 2 FIX: 
        const section = cardElement ? cardElement.closest('.sc-part-section') : document.querySelector('.sc-part-section[style*="display: block"]');
        const btnNext = section ? section.querySelector('.sc-btn-next') : null;
        
        if (btnNext) {
            btnNext.disabled = false;
            btnNext.style.background = '#e71616';
            btnNext.style.color = '#fff';
            btnNext.style.cursor = 'pointer';
        }

        // Target specific choice element selection ID 262
        if (Number(selectedChoiceState.choiceId) === 262) {
            const container = document.createElement('div');
            container.id = 'engraving-text-container';
            container.style.cssText = 'margin-top: 20px; margin-bottom: 10px; width: 100%; clear: both; display: block; box-sizing: border-box;';

            const currentText = selectedChoiceState.custom_text || '';

            container.innerHTML = `
                <label style="display:block; font-size:11px; text-transform:uppercase; color:#888; font-family:sans-serif; margin-bottom:8px; letter-spacing:1px; font-weight:700;">Your Engraving Text <span style="color:#e71616;">*</span></label>
                <textarea id="custom-engraving-input" placeholder="Enter engraving here (e.g., English, Japanese Kanji, Dates)..." style="width:100%; padding:12px; border:1px solid #ced4da; font-family:inherit; font-size:14px; background:#fff; outline:none; box-sizing:border-box; resize:vertical; min-height:60px; border-radius:4px; transition: border 0.3s ease;">${currentText}</textarea>
                
                <!-- INLINE ERROR MESSAGE -->
                <div id="engraving-error-msg" style="display:none; color: #e71616; font-size: 12px; font-weight: 700; margin-top: 6px;">
                    ⚠ Please enter your engraving text to proceed.
                </div>

                <div style="background:#fdf6ec; border:1px solid #faebd7; padding:10px 12px; font-size:12px; color:#b8860b; margin-top:8px; font-family:sans-serif; border-radius:4px; line-height: 1.4;">
                    Any text including Japanese, English, Chinese characters, names, dates, quotes, or custom text.
                </div>
            `;

            // Append the textarea block directly beneath the card grid layout wrapper
            let targetGrid = document.querySelector('.sc-choices-grid') || document.querySelector('.sc-cards-container');
            if (cardElement && !targetGrid) {
                targetGrid = cardElement.parentElement;
            }

            if (targetGrid) {
                targetGrid.after(container);
            }

            // Bind updates instantly as the custom input string scales
            const textarea = container.querySelector('#custom-engraving-input');
            const errorMsg = container.querySelector('#engraving-error-msg');

            textarea.addEventListener('input', (e) => {
                selectedChoiceState.custom_text = e.target.value;
                
                // 🚨 LIVE WORD FILTER CHECK 🚨
                if (this.containsBlockedWord(e.target.value)) {
                    errorMsg.textContent = '⚠ This text contains restricted words.';
                    errorMsg.style.display = 'block';
                    textarea.style.borderColor = '#e71616';
                    
                    // 🚨 NEXT BUTTON  LOCK  🚨
                    if (btnNext) {
                        btnNext.disabled = true;
                        btnNext.style.background = '#eee'; // Grey background
                        btnNext.style.color = '#aaa';      // Grey text
                        btnNext.style.cursor = 'not-allowed';
                    }
                } else {
                    // ✅ NEXT BUTTON  UNLOCK  ✅
                    if (btnNext) {
                        btnNext.disabled = false;
                        btnNext.style.background = '#e71616';
                        btnNext.style.color = '#fff';
                        btnNext.style.cursor = 'pointer';
                    }

                    // Remove error styling instantly when user starts typing
                    if (e.target.value.trim() !== '') {
                        errorMsg.style.display = 'none';
                        textarea.style.borderColor = '#ced4da';
                    } else {
                        errorMsg.textContent = '⚠ Please enter your engraving text to proceed.';
                        errorMsg.style.display = 'block';
                        textarea.style.borderColor = '#e71616';
                    }
                }
            });
        } else {
            // Clean out text properties if the customer switches choice option back to "None"
            if (this.selections[part.slug]) {
                delete this.selections[part.slug].custom_text;
            }
        }
    }

    changeStep(direction) {
        // IMMEDIATE VALIDATION ON THE CURRENT STEP (ENGRAVINGS)
        if (direction === 1 && this.parts[this.currentStep] && this.parts[this.currentStep].slug === 'engravings') {
            const engSel = this.selections['engravings'];
            if (engSel && (engSel.label.toLowerCase().includes('custom') || engSel.choiceId == 262)) {
                if (!engSel.custom_text || engSel.custom_text.trim() === '') {
                    // Show inline error message and red border
                    const errorMsg = document.getElementById('engraving-error-msg');
                    const textarea = document.getElementById('custom-engraving-input');
                    if (errorMsg) errorMsg.style.display = 'block';
                    if (textarea) textarea.style.borderColor = '#e71616';
                    return; // Stop navigation immediately
                }
            }
        }

        let newStep = this.currentStep + direction;

        // MAGIC SKIP LOGIC FOR RAYSKIN MERGE
        if (direction === 1 && this.parts[this.currentStep]) {
            const currName = this.parts[this.currentStep].name.toLowerCase();
            if (currName.includes('rayskin color')) {
                const nextPart = this.parts[this.currentStep + 1];
                if (nextPart && nextPart.name.toLowerCase().includes('wrap style')) {
                    newStep++;
                }
            }
        } else if (direction === -1 && this.parts[newStep]) {
            const targetName = this.parts[newStep].name.toLowerCase();
            if (targetName.includes('wrap style')) {
                newStep--;
            }
        }

        if (newStep === this.parts.length) {
            const req = this.parts.filter(p => p.required);
            const done = req.length > 0 && req.every(p => this.selections[p.slug]);

            if (!done) {
                alert("Please select all required options to proceed to Review.");
                return; // Stop navigation
            }
        }

        if (newStep >= 0 && newStep <= this.parts.length) {
            this.showStep(newStep);
        }
    }

    showStep(stepIndex) {
        document.querySelectorAll('.sc-part-section').forEach((el, idx) => {
            el.style.display = idx === stepIndex ? 'block' : 'none';
        });
        this.currentStep = stepIndex;
        const currentPart = this.parts[stepIndex];
        // MAGIC VISUAL MERGE FOR RAYSKIN
        if (currentPart && currentPart.name.toLowerCase().includes('rayskin color')) {
            const nextPart = this.parts[stepIndex + 1];
            if (nextPart && nextPart.name.toLowerCase().includes('wrap style')) {
                const currentSection = document.getElementById(`sc-sec-${stepIndex}`);
                const nextSection = document.getElementById(`sc-sec-${stepIndex + 1}`);

                if (currentSection && nextSection) {
                    nextSection.style.display = 'block';

                    const titleHeader = nextSection.querySelector('h2');
                    if (titleHeader) {
                        titleHeader.style.fontSize = '20px';
                        titleHeader.style.marginTop = '0px';
                        titleHeader.style.paddingTop = '20px';
                        // titleHeader.style.borderTop = '1px dashed #ccc';
                    }

                    const tabHeader = nextSection.querySelector('div');
                    if (tabHeader) tabHeader.style.display = 'none';

                    // HIDE ENTIRE FIRST BUTTON ROW 
                    const firstBtnRow = currentSection.querySelector('div[style*="justify-content: space-between"]');
                    if (firstBtnRow) firstBtnRow.style.display = 'none';

                    // HIDE ONLY SECOND BACK BUTTON 
                    const secondBack = nextSection.querySelector('.sc-btn-back');
                    if (secondBack) secondBack.style.visibility = 'visible';
                }
            }
        }
        const columns = document.querySelector('.sc-columns');
        const progressFill = document.getElementById('sc-progress-fill');
        const progressText = document.getElementById('sc-progress-text');

        if (stepIndex === this.parts.length) {
            columns.classList.add('review-mode');
            if (progressFill) progressFill.style.width = `100%`;
            if (progressText) progressText.textContent = `REVIEW BUILD`;

            // NEW MAGIC: Clone the live SVG to the Review Step
            const mainSvg = document.getElementById('sword-svg');
            const reviewSvgWrapper = document.getElementById('sc-review-svg-wrapper');
            if (mainSvg && reviewSvgWrapper) {
                // True creates a deep copy of the SVG exactly as it looks right now
                const clonedSvg = mainSvg.cloneNode(true);
                // Change the ID so it doesn't conflict with the original SVG
                clonedSvg.id = 'sword-svg-review';
                // Clear the wrapper and add the fresh copy
                reviewSvgWrapper.innerHTML = '';
                reviewSvgWrapper.appendChild(clonedSvg);
            }

        } else {
            columns.classList.remove('review-mode');
            const currentPart = this.parts[stepIndex];
            const progressPercent = ((stepIndex + 1) / this.parts.length) * 100;

            if (progressFill) progressFill.style.width = `${progressPercent}%`;

            if (progressText) {
                progressText.textContent = `${stepIndex + 1}. ${currentPart.name.toUpperCase()}`;
            }
        }

        const navBar = document.getElementById('sc-full-top-nav');
        const navHeight = navBar ? navBar.offsetHeight : 0;
        const rightPanel = document.querySelector('.sc-right');
        if (rightPanel) {
            const top = rightPanel.getBoundingClientRect().top + window.scrollY - navHeight;
            window.scrollTo({
                top,
                behavior: 'smooth'
            });
        }

        this.updateTabNav();
    }

    isColorChoice(label) {
        const l = label.toLowerCase();
        return ['black', 'blue', 'red', 'gold', 'brown', 'white', 'navy'].some(c => l.includes(c)) && label.length < 12;
    }

    swatchColor(label) {
        const l = label.toLowerCase();
        if (l.includes('black')) return '#111';
        if (l.includes('blue')) return '#1a3a6e';
        if (l.includes('red')) return '#8b0000';
        if (l.includes('gold')) return '#b8860b';
        if (l.includes('brown')) return '#5c2e00';
        if (l.includes('white')) return '#f0ebe0';
        if (l.includes('navy')) return '#0d1b3e';
        return '#888';
    }

    icon(sku) {
        const map = {
            '1045': '⚔',
            '1060': '🗡',
            'T10': '◆',
            'BLC': '◼',
            'BLU': '🔵',
            'RED': '🔴',
            'GLD': '🟡',
            'NBH': '—',
            'SBH': '/',
            'HJ05': '〰',
            'HJ08': '🐉',
            'HJ11': '🌸',
            'T03': '⊙',
            'T07': '🎋',
            'TT12': '◈',
            'CT12': '🐲',
            'CT18': '🌺',
            'GLOSS': '⬛',
            'MATTE': '◼',
            'WOOD': '🪵',
            'RATTAN': '〰',
            'EBONY': '🖤',
            'IMT': '○',
            'GEN': '●',
            'BRASS': '🥉',
            'COPPER': '🟠',
        };
        return map[sku] || '◆';
    }

    shortLabel(label, sku) {
        if (label.length <= 14) return label;
        return sku || label.substring(0, 12) + '…';
    }

    pick(part, choice, card) {
        this.selections[part.slug] = {
            choiceId: choice.id,
            label: choice.label,
            price: parseFloat(choice.price),
            isBase: choice.is_base,
            skuCode: choice.sku_code,
            imageUrl: choice.image_url
        };

        // ── PASS THE NEW SELECTION INSTANCE SO DATA PERSISTS ──
        this.toggleEngravingInput(part, this.selections[part.slug], card)

        document.querySelectorAll(`[data-part="${part.slug}"]`)
            .forEach(c => c.classList.remove('active'));
        card.classList.add('active');

        this.updateSVG(part.slug, choice);
        this.updateSummary();
        this.updateBtn();
        this.updateAccordionHeader(part, choice);
    }

    updateAccordionHeader(part, choice) {
        if (!part.groups) return;
        const group = part.groups.find(g => g.choices && g.choices.some(c => c.id === choice.id));
        if (!group) return;
        const header = document.querySelector(`.sc-accordion-header[data-group-id="${group.id}"][data-part-slug="${part.slug}"]`);
        if (!header) return;
        const priceInfo = header.querySelector('.sc-acc-price-info');
        if (!priceInfo) return;
        const price = parseFloat(choice.price);
        const priceStr = price === 0 ? 'Included' : '+$' + price.toFixed(0);
        const colBg = WRAP_BG_COLORS[choice.sku_code];
        const dot = colBg ?
            `<span style="display:inline-block;width:8px;height:8px;border-radius:50%;background:${colBg.bg};border:1px solid rgba(0,0,0,0.15);margin-right:5px;vertical-align:middle;"></span>` :
            '';
        const shortName = choice.label.includes('—') ? choice.label.split('—').pop().trim() : choice.label;
        priceInfo.innerHTML = `${dot}<span style="color:#333;margin-right:6px;">${shortName}</span><span style="color:#888;">${priceStr}</span>`;
    }

    updateSVG(slug, choice) {
        const lbl = choice.label.toLowerCase();
        const sku = choice.sku_code;

        if (slug === 'blade-color') {
            let key = 'black';
            if (lbl.includes('blue')) key = 'blue';
            else if (lbl.includes('red')) key = 'red';
            else if (lbl.includes('gold')) key = 'gold';
            const c = BLADE_COLORS[key];
            const b0 = document.getElementById('bl0');
            const b1 = document.getElementById('bl1');
            if (b0) b0.setAttribute('stop-color', c.c0);
            if (b1) b1.setAttribute('stop-color', c.c1);
        }
        if (slug === 'blade-steel') {
            const el = document.getElementById('svg-lbl-blade');
            if (el) el.textContent = choice.label;
        }
        if (slug === 'blade-color') {
            const bladeEl = document.getElementById('svg-lbl-blade');
            const bladeSel = this.selections['blade-steel'];
            if (bladeEl && bladeSel) {
                bladeEl.textContent = bladeSel.label + ' · ' + choice.label;
            }
        }
        if (slug === 'handle-wrap') {
            let col = '#1a0e06';
            let lnCol = 'rgba(0,0,0,0.55)';
            Object.entries(WRAP_COLORS).forEach(([k, v]) => {
                if (lbl.includes(k)) {
                    col = v;
                }
            });
            if (lbl.includes('white') || lbl.includes('cream')) {
                lnCol = 'rgba(180,170,150,0.6)';
            }
            const tk = document.getElementById('sv-tk');
            if (tk) tk.setAttribute('fill', col);
            const wr = document.getElementById('sv-wr');
            if (wr) wr.querySelectorAll('line').forEach(l => l.setAttribute('stroke', lnCol));
            const el = document.getElementById('svg-lbl-wrap');
            if (el) el.textContent = choice.label;
        }
        if (slug === 'tsuba') {
            const col = TSUBA_COLORS[sku] || '#888';
            const tO = document.getElementById('sv-tO');
            const tI = document.getElementById('sv-tI');
            if (tO) tO.setAttribute('fill', col);
            if (tI) tI.setAttribute('stroke', col);
            const el = document.getElementById('svg-lbl-tsuba');
            if (el) el.textContent = sku || choice.label;
        }
        if (slug === 'sageo') {
            const col = SAGEO_COLORS[sku] || '#2a2a2a';
            const sg = document.getElementById('sv-sg');
            if (sg) sg.setAttribute('stroke', col);
            const el = document.getElementById('svg-lbl-sageo');
            if (el) el.textContent = choice.label;
        }
    }

    updateSummary() {
        const rows = document.getElementById('sc-rows');
        const reviewList = document.getElementById('sc-review-summary-list');

        const pencil = `<svg width="10" height="10" viewBox="0 0 16 16" fill="none" stroke="#bbb" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M11.5 1.5l3 3L5 14H2v-3L11.5 1.5z"/></svg>`;

        if (rows) {
            rows.innerHTML = this.parts.map((part, partIndex) => {

                if (part.name.toLowerCase().includes('wrap style')) return '';

                let s = this.selections[part.slug];
                let price = s ? parseFloat(s.price) : 0;
                let displayLabel = s ? s.label : '—';
                let displayKey = this.shortKey(part.name);


                if (part.name.toLowerCase().includes('rayskin color')) {
                    displayKey = 'RAYSKIN';
                    const wrapPart = this.parts.find(p => p.name.toLowerCase().includes('wrap style'));
                    if (wrapPart) {
                        const wrapSel = this.selections[wrapPart.slug];
                        if (wrapSel) {
                            displayLabel = `${displayLabel} / ${wrapSel.label}`;
                            price += parseFloat(wrapSel.price);
                        } else {
                            displayLabel = `${displayLabel} / —`;
                        }
                    }
                }

                const priceHtml = price > 0 ?
                    `<span class="sc-summary-price" style="color:#e71616;">+$${price.toFixed(0)}</span>` :
                    `<span class="sc-summary-price" style="color:#ddd;">–</span>`;

                return `<div class="sc-summary-row" onclick="window.configuratorInstance.showStep(${partIndex})" style="cursor:pointer;">
                  <span class="sc-summary-key">${displayKey}</span>
                  <span class="sc-summary-val">${displayLabel}</span>
                  ${priceHtml}
                  <span class="sc-summary-chevron">${pencil}</span>
                </div>`;
            }).join('');
        }

        if (reviewList) {
            reviewList.innerHTML = this.parts.map(part => {
                // 🚨 HIDE WRAP STYLE ROW FROM REVIEW
                if (part.name.toLowerCase().includes('wrap style')) return '';

                const s = this.selections[part.slug];
                let displayLabel = s ? s.label : 'Pending Selection';
                let displayName = part.name;

                // 🚨 MERGE COLOR AND STYLE FOR REVIEW
                if (part.name.toLowerCase().includes('rayskin color')) {
                    displayName = 'RAYSKIN ';
                    const wrapPart = this.parts.find(p => p.name.toLowerCase().includes('wrap style'));
                    if (wrapPart) {
                        const wrapSel = this.selections[wrapPart.slug];
                        displayLabel = (s ? s.label : 'Pending Selection') + ' / ' + (wrapSel ? wrapSel.label : 'Pending Selection');
                    }
                }

                let imgHtml = '';
                let hoverEvent = '';
                let labelStyle = 'color:#111; font-weight: 700;';

                if (s && s.imageUrl && s.imageUrl.trim() !== '' && s.imageUrl !== 'null' && s.imageUrl !== null) {
                    imgHtml = `<img src="${s.imageUrl}" class="sc-hover-preview" style="display:none; position:absolute; right:0; bottom:100%; margin-bottom:8px; width:150px; height:80px; object-fit:fill; border:2px solid #111; border-radius:6px; box-shadow: 0px 8px 20px rgba(0,0,0,0.25); z-index:999; background:#fff; pointer-events:none;" />`;
                    hoverEvent = `onmouseenter="this.querySelector('.sc-hover-preview').style.display='block'" onmouseleave="this.querySelector('.sc-hover-preview').style.display='none'"`;
                    labelStyle += ' cursor:pointer; text-decoration: underline dotted #888; text-underline-offset: 4px;';
                }

                let engravingTextHtml = '';
                if (part.slug === 'engravings' && s && s.custom_text) {
                    engravingTextHtml = `
                    <div style="font-size: 12px; color: #b8860b; background: #fdf6ec; padding: 6px 10px; margin-top: 6px; border-radius: 4px; font-weight: 600; display: block; border: 1px dashed #faebd7; width: 100%; box-sizing: border-box;">
                        Text to Engrave: "${s.custom_text}"
                    </div>`;
                }

                return `
                <div style="position:relative; display:flex; flex-direction: column; margin-bottom: 2px; font-size: 12px; padding-bottom: 5px; border-bottom: 1px solid #e5e7eb;">
                  <div style="display:flex; justify-content:space-between; width: 100%;" ${hoverEvent}>
                    <span style="font-weight:600; color:#555;">${displayName}</span>
                    <span style="${labelStyle}">${displayLabel}</span>
                    ${imgHtml}
                  </div>
                  ${engravingTextHtml}
                </div>`;
            }).join('');
        }

        //  UPDATE: 5 WEEKS AND 7 WEEKS LOGIC 

        // 1. Set base time to 5 weeks (fetching from admin panel if available)
        let baseTime = this.reviewSettings ? this.reviewSettings.production_time : '~5 weeks';
        let isFullWrap = false;

        // 2. Loop through selections to check if the user selected "Fully Wrapped"
        for (const key in this.selections) {
            const sel = this.selections[key];
            if (sel && sel.label) {
                const choiceName = sel.label.toLowerCase();
                if (choiceName.includes('fully wrapped') || choiceName.includes('full wrap')) {
                    isFullWrap = true;
                    break;
                }
            }
        }

        // 3. Apply 7 weeks if 'Fully Wrapped' is selected, otherwise apply 5 weeks
        const finalTime = isFullWrap ? '~7 weeks' : baseTime;

        // 4. Update the text dynamically on the screen (Sidebar and Review Page)
        const sidebarTimeEl = document.getElementById('sc-sidebar-time-display');
        if (sidebarTimeEl) sidebarTimeEl.textContent = finalTime.toUpperCase();

        const reviewTimeEl = document.getElementById('sc-review-delivery-time');
        if (reviewTimeEl) reviewTimeEl.textContent = finalTime;

        this.fetchPrice();
    }

    async fetchPrice() {
        try {
            const ids = {};
            this.parts.forEach(part => {
                if (this.selections[part.slug]) {
                    ids[part.slug] = this.selections[part.slug].choiceId;
                } else if (part.choices && part.choices.length > 0) {
                    const baseChoice = part.choices.find(c => c.is_base) || part.choices[0];
                    ids[part.slug] = baseChoice.id;
                }
            });

            // FIX HERE: Pass sword_box_added state to backend calculate API
            const res = await fetch(`${CONFIGURATOR_API}/calculate`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'ngrok-skip-browser-warning': 'true'
                },
                body: JSON.stringify({
                    selections: ids,
                    sword_box_added: this.isBoxAdded || false // Sends true/false dynamically
                })
            });
            const data = await res.json();

            if (data.success) {
                this.total = data.total;
                const sidebarPrice = document.getElementById('sc-price');
                const topPrice = document.getElementById('sc-top-price-display');
                const finalBtnPrice = document.getElementById('sc-review-total-btn');

                if (sidebarPrice) {
                    sidebarPrice.textContent = data.formatted;
                    sidebarPrice.classList.remove('is-loading'); // Show it
                }
                if (topPrice) {
                    topPrice.textContent = data.formatted;
                    topPrice.classList.remove('is-loading'); // Show it
                }
                if (finalBtnPrice) {
                    finalBtnPrice.textContent = data.formatted;
                    finalBtnPrice.classList.remove('is-loading'); // Show it
                }
                this.updateBtn();
            }
        } catch (e) {}
    }

    updateBtn() {
        const btn = document.getElementById('sc-final-checkout-btn');
        if (!btn) return;

        // Check if all required parts are selected
        const req = this.parts.filter(p => p.required);
        const done = req.every(p => this.selections[p.slug]); // Removed req.length > 0 check to prevent bugs

        if (done) {
            btn.disabled = false;
            btn.style.background = '#000'; // Active Red Color
            btn.style.color = '#fff';
            btn.style.cursor = 'pointer';

            // Keep the text exactly as ADD TO CART
            btn.innerHTML = `ADD TO CART • $${this.total.toFixed(2)}`;
            btn.onclick = () => this.addToCart();
        } else {
            btn.disabled = true;
            btn.style.background = '#eee';
            btn.style.color = '#aaa';
            btn.style.cursor = 'not-allowed';

            // Show which required part is missing
            const miss = req.find(p => !this.selections[p.slug]);
            btn.innerHTML = miss ? `PLEASE SELECT: ${miss.name.toUpperCase()}` : 'ADD TO CART';
        }
    }

    async addToCart() {
        const btn = document.getElementById('sc-final-checkout-btn');
        const katanaNameInput = document.getElementById('custom-katana-name');
        const customKatanaName = katanaNameInput ? katanaNameInput.value.trim() : '';
        let errorMsg = document.getElementById('katana-name-error');

        // 1. Validation check 
        if (!customKatanaName) {
            if (!errorMsg) {
                errorMsg = document.createElement('div');
                errorMsg.id = 'katana-name-error';
                errorMsg.style.cssText = 'color: #e71616; font-size: 12px; font-weight: 700; margin-top: 5px;';
                katanaNameInput.after(errorMsg);
            }
            errorMsg.textContent = '⚠ Please name your Katana to proceed.';
            katanaNameInput.style.borderColor = '#e71616';
            katanaNameInput.focus();
            return;
        }

        if (errorMsg) errorMsg.remove();
        katanaNameInput.style.borderColor = '#d1d5db';

        btn.disabled = true;
        btn.innerHTML = 'Building your katana...';

        // 2. Prepare IDs for pricing/creation
        const ids = {};
        this.parts.forEach(part => {
            if (this.selections[part.slug]) {
                ids[part.slug] = this.selections[part.slug].choiceId;
            }
        });

        // 3. Email Resolver Helper
        function getCustomerEmail() {
            // Priority 1: Shopify logged-in customer 
            if (window.customerEmail) return window.customerEmail;
            if (window.userEmail) return window.userEmail;

            // Priority 2: Klaviyo __kla_id cookie
            const klaviyoCookieEmail = getKlaviyoEmail();
            if (klaviyoCookieEmail) return klaviyoCookieEmail;

            // Priority 4: Fallback to guest token
            return 'guest_' + Math.random().toString(36).substr(2, 9);
        }
        
        // Capture exact ID at the millisecond of checkout
        const currentCustomerId = window.customerId || "";

        // 4. Metafields object preparation (WITH CLEAN READABLE KEYS FOR KLAVIYO EMAILS)
        const selectionsForMetafields = {};
        Object.entries(this.selections).forEach(([key, sel]) => {
            const part = this.parts.find(p => p.slug === key);
            if (!part) return;

            if (part.name.toLowerCase().includes('wrap style')) return;

            let cleanKey = part.name; // Exact safa naam uthayega jaise 'Steel Type'
            let finalLabel = sel.label || sel;
            
            if (part.name.toLowerCase().includes('rayskin color')) {
                cleanKey = 'Rayskin & Wrap Style';
                const wrapPart = this.parts.find(p => p.name.toLowerCase().includes('wrap style'));
                if (wrapPart && this.selections[wrapPart.slug]) {
                    finalLabel = finalLabel + ' / ' + this.selections[wrapPart.slug].label;
                }
            }

            // 🚨 Custom Engraving Text Merge Logic 🚨
            if (key === 'engravings' && sel.custom_text) {
                finalLabel = `${finalLabel} — Text: "${sel.custom_text}"`;
            }
            
            selectionsForMetafields[cleanKey] = finalLabel; 
        });

        const metaPayload = {
            customer_email: getCustomerEmail(),
            customer_id: currentCustomerId,
            configured_at: new Date().toISOString(),
            configuration_selections: JSON.stringify({
                selections: selectionsForMetafields, 
                total_price: this.total
            }),
            product_url: window.location.href,
            klaviyo_exchange_id: getKlaviyoCookie() || ""
        };

        // 5. API Call
        try {
            const createRes = await fetch(`${CONFIGURATOR_API}/create-product`, {
                method: 'POST',
                headers: {
                   'Content-Type': 'application/json',
                   'ngrok-skip-browser-warning': 'true',
                },
                body: JSON.stringify({
                    selections: ids,
                    engraving_text: this.selections['engravings']?.custom_text || '',
                    sword_box_added: this.isBoxAdded || false,
                    katana_name: customKatanaName,
                    metafields: metaPayload 
                }) 
            });

            const createData = await createRes.json();

            if (!createData.success) {
                throw new Error(createData.message || createData.errors?.join(', ') || 'Failed to create product.');
            }
            btn.innerHTML = 'Adding to cart...';
            const formData = new FormData();
            formData.append('id', createData.variant_id);
            formData.append('quantity', 1);

            // MAGIC MERGE FOR SHOPIFY CART PAYLOAD
            Object.entries(this.selections).forEach(([key, sel]) => {
                const part = this.parts.find(p => p.slug === key);

                if (part) {
                    // Wrap Style skip  
                    if (part.name.toLowerCase().includes('wrap style')) return;

                    let propLabel = sel.label;
                    let propKey = part.name;

                    // Rayskin Color aur Wrap Style Merge
                    if (part.name.toLowerCase().includes('rayskin color')) {
                        propKey = 'Rayskin'; 
                        const wrapPart = this.parts.find(p => p.name.toLowerCase().includes('wrap style'));
                        if (wrapPart && this.selections[wrapPart.slug]) {
                            propLabel = propLabel + ' / ' + this.selections[wrapPart.slug].label;
                        }
                    }

                    // ENGRAVING TEXT MERGE 
                    if (key === 'engravings' && sel.custom_text) {
                        propLabel = `${propLabel} — Text: "${sel.custom_text}"`;
                    }

                    // Final property append
                    formData.append(`properties[${propKey}]`, propLabel);
                } else {
                    // Addons  
                    formData.append(`properties[${key}]`, sel.label);
                }
            });
            formData.append('properties[_Build SKU]', createData.sku);
            formData.append('properties[_Config ID]', createData.config_id);
            formData.append('properties[Total Price]', '$' + createData.total.toFixed(2));

            const cartRes = await fetch('/cart/add.js', {
                method: 'POST',
                body: formData,
            });

            if (cartRes.ok) {
                this.showSuccessMessage();
            } else {
                const err = await cartRes.json();
                throw new Error(err.description || 'Could not add to cart.');
            }
            document.dispatchEvent(new CustomEvent('cart:refresh', {
                bubbles: true
            }));

            const cartDrawer = document.querySelector('cart-drawer');
            if (cartDrawer) {
                setTimeout(() => cartDrawer.open(), 300);
            }
        } catch (e) {
            alert('Error: ' + e.message);
            btn.disabled = false;
            btn.innerHTML = `ADD TO CART • $${this.total.toFixed(2)}`;
        }
    }

    showSuccessMessage() {
        const wrap = document.getElementById('sc-sections');
        wrap.innerHTML = `
            <div style="text-align: center; padding: 0px;">
                <div style="width: 64px;height: 64px;background: #1a7a1a;border-radius: 50%;display: flex;align-items: center;justify-content: center;margin: 0 auto 18px;font-size: 28px;">🛒</div>
                <h2 style="font-size: 36px; font-weight: 800; margin-bottom: 10px;">ADDED TO CART!</h2>
                <p style="margin-bottom: 10px;">Your custom katana has been added. Production begins once your order is confirmed.</p>
                
                <div style="background:#fff; padding:0px; text-align: left;margin-bottom: 25px;border: 1px solid #e5e5e5;">
                    <h3 style="background: #000;color: #fff;padding: 10px;margin: 0;font-size: 16px;">ORDER SUMMARY</h3>
                    <div id="sc-final-summary-rows" style="padding: 10px;"></div>
                </div>

                <a href="/cart" style="display:block; background: #e71616; color: #fff; padding: 18px; text-decoration: none; font-weight:700; font-size: 16px; max-width: 100%; margin: 0 auto 15px auto;">PROCEED TO CHECKOUT →</a>
                <a href="javascript:location.reload()" style="display: block;text-decoration: none;background: transparent;color: #12141f;border: 1.5px solid #12141f;padding: 12px;font-family: 'Barlow Condensed', sans-serif;
          font-size: 12px;font-weight: 700;letter-spacing: .1em;cursor: pointer;text-transform: uppercase;width: 100%;">← BUILD ANOTHER</a>
            </div>
        `;

        document.getElementById('sc-final-summary-rows').innerHTML = this.parts.map(p => {
            if (p.name.toLowerCase().includes('wrap style')) return '';

            let s = this.selections[p.slug];
            let displayLabel = s ? s.label : '—';
            let displayName = p.name;

            if (p.name.toLowerCase().includes('rayskin color')) {
                displayName = 'RAYSKIN (SAMEGAWA)';
                const wrapPart = this.parts.find(x => x.name.toLowerCase().includes('wrap style'));
                if (wrapPart) {
                    const wrapSel = this.selections[wrapPart.slug];
                    displayLabel = (s ? s.label : '—') + ' / ' + (wrapSel ? wrapSel.label : '—');
                }
            }
            if (p.slug === 'engravings' && s && s.custom_text) {
                displayLabel += ` — Text: "${s.custom_text}"`;
            }

            return `
            <div style="position: relative;display: flex;margin-bottom: 2px;font-size: 12px;padding-bottom: 5px;border-bottom: 1px solid #e5e7eb;justify-content: space-between;">
                <span style="font-weight:600; text-transform:uppercase; color: #555;  font-size:12px;">${displayName}</span>
                <span style="font-weight:600; text-transform:uppercase; color: #111; font-size:12px; text-align:right;">${displayLabel}</span>
            </div>
            `;
        }).join('');
    }

    showLoading() {
        this.container.innerHTML = `
        <div style="padding:4rem;text-align:center;color:#111;font-family:sans-serif;font-size:16px;letter-spacing:0.05em;">
            <div style="font-size: 40px; margin-bottom: 15px;">⚔️</div>
            <div style="font-weight: 800; text-transform: uppercase; font-size: 18px;">Forging your custom blade...</div>
            <div style="color:#666; font-size: 13px; margin-top: 8px;">The master smith is preparing your forge.</div>
        </div>
    `;
    }
}

document.addEventListener('DOMContentLoaded', () => {
    const container = document.getElementById('sword-configurator-root');
    if (container) {
        window.configuratorInstance = new SwordConfigurator(container);
    }
});

// function getKlaviyoCookie() {
//   const match = document.cookie.match(/(^|;)\s*_kx\s*=\s*([^;]+)/);
//   return match ? decodeURIComponent(match[2]) : null;
// }

// NEW: Extract Email from Klaviyo __kla_id cookie
function getKlaviyoEmail() {
  const match = document.cookie.match(/(^|;)\s*__kla_id\s*=\s*([^;]+)/);
  if (!match) return null;
  try {
    const decoded = JSON.parse(atob(decodeURIComponent(match[2])));
    return decoded.$email || null;
  } catch(e) { return null; }
}

function getKlaviyoCookie() {
  const match = document.cookie.match(/(^|;)\s*_kx\s*=\s*([^;]+)/);
  return match ? decodeURIComponent(match[2]) : null;
}